// extracted by mini-css-extract-plugin
module.exports = {"reportButton":"functions_reportButton__34qPM","alertModalButtons":"functions_alertModalButtons__1Czhe"};